import { format } from "date-fns";
import { RcRow } from "@/constants/rc";

// Ported from the Feishu bitable "arpu链接" formula field: a Friday dashboard
// deep link. 产品账号 is constant across all apps; 产品pid equals our app id.
// The formula used "today" as the end date for still-running experiments —
// we mirror that when endDate is absent.
const FRIDAY_BASE = "https://friday.stickermobi.com/dashboard/309-sticker-ab";
const PRODUCT_ACCOUNT = "378886164";

export const buildArpuLink = (rc: RcRow): string | null => {
  if (rc.type !== "AB_EXPERIMENT" || !rc.startDate) return null;
  const start = format(new Date(rc.startDate), "yyyy-MM-dd");
  const end = format(rc.endDate ? new Date(rc.endDate) : new Date(), "yyyy-MM-dd");
  const p = new URLSearchParams();
  p.set("产品账号", PRODUCT_ACCOUNT);
  p.set("开始日期", start);
  p.set("结束日期", end);
  p.set("产品pid", rc.appId);
  p.set("实验id", "");
  ["ARPDAU", "AvgImps", "Impression", "DAU", "TotalRevenue", "eCPM"].forEach(
    (m, i) => p.set(`指标${i + 1}`, m)
  );
  ["U", "Revenue", "ARPU", "Imp", "AvgImp", "eCPM"].forEach((m, i) =>
    p.set(`指标_${i + 1}`, m)
  );
  ["A", "B", "C", "D", "E", "F"].forEach((g) => p.append("ab组", g));
  p.set("adpid", "");
  p.set("tab", "197-arpdau");
  return `${FRIDAY_BASE}?${p.toString()}`;
};
